function myTemSearch() {
    var input, filter, table, tr, td, i, txtValue;
    input= document.getElementsByClassName("historytrx")[0];
    filter= input.value;
    table= document.getElementsByClassName("history-table")[0];
    tr= table.getElementsByTagName("tr");
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByTagName("td")[1];
      if (td) {
        txtValue = td.textContent || td.innerText;
        if (txtValue.indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";
        }
      }       
    }
  }